module.exports = __webpack_public_path__ + "media/src/images/step-03-47f671946b982ae50f52af7d33bc40d2.svg";